<template>
  <q-card
    class="setOverallTargetForm"
    style="width: 750px; max-width: 90vw; height: 550px; max-height: 90vh"
  >
    <q-card-section class="q-pa-md text-white targetFormHeader shadow-6">
      <h3 class="q-my-none">
        Set Overall Target
        <q-btn
          flat
          round
          icon="mdi-close"
          class="float-right"
          @click="close"
          style="position: absolute; top: 10px; right: 10px"
        ></q-btn>
      </h3>
    </q-card-section>
    <q-card-section class="q-pa-md" style="height: calc(100% - 132px)">
      <div class="row items-center">
        <p class="text-accent suggestedTitle">
          Please set an overall target by choosing the below options
        </p>
      </div>

      <div class="row items-center q-mb-md">
        <span class="goalBuilder__sentence">
          I want to Reduce the use of {{ outcome.label }}</span
        >
      </div>
      <div class="row items-center">
        <span class="goalBuilder__sentence"> in </span>
        <q-input
          class="q-ml-sm"
          v-model="baselineFormattedSelectedYear"
          dense
          filled
          style="width: 100px"
        >
          <template v-slot:append>
            <q-icon name="mdi-chevron-down"></q-icon>
          </template>
          <template>
            <q-popup-proxy
              ref="baselineYearProxy"
              transition-show="scale"
              transition-hide="scale"
              :breakpoint="0"
              v-model="baselineYearDialog"
            >
              <q-date
                minimal
                v-model="baselineSelectedYear"
                default-view="Years"
                emit-immediately
                @input="checkCalendar"
              >
              </q-date>
            </q-popup-proxy>
          </template>
        </q-input>
        <span class="goalBuilder__sentence q-ml-sm"> by </span>
        <q-input
          style="width: 120px"
          class="q-ml-sm"
          v-model="reductionPercentage"
          dense
          filled
          type="number"
          hide-bottom-space
          :rules="[
            (val) => !!val || 'Field is required',
            (val) => !isNaN(parseFloat(val)) || 'Value must be a number',
          ]"
        >
          <template v-slot:append>
            <span>%</span>
          </template>
        </q-input>
        <span class="goalBuilder__sentence q-ml-sm"> before </span>
        <q-input
          class="q-ml-sm"
          v-model="dueFormattedSelectedYear"
          dense
          filled
          style="width: 100px"
        >
          <template v-slot:append>
            <q-icon name="mdi-chevron-down"></q-icon>
          </template>
          <template>
            <q-popup-proxy
              ref="dueYearProxy"
              transition-show="scale"
              transition-hide="scale"
              :breakpoint="0"
              v-model="dueYearDialog"
            >
              <q-date
                minimal
                v-model="dueSelectedYear"
                default-view="Years"
                emit-immediately
                @input="checkCalendar"
              >
              </q-date>
            </q-popup-proxy>
          </template>
        </q-input>
      </div>
      <div class="row q-col-gutter-md">
        <div class="col-12">
          <p class="text-accent suggestedTitle q-my-md">
            The impact this will have
          </p>
        </div>
        <div class="col-12">
          <div
            class="row q-col-gutter-md"
            v-if="
              !baselineDataLoading &&
              baselineData.date != null &&
              baselineData.unitValue != null
            "
          >
            <div class="col-4 highlight impactStatsLabels">Currently</div>
            <div class="col-4 highlight impactStatsLabels">Target</div>
            <div class="col-4 highlight impactStatsLabels">Reduction of</div>
            <div class="col-4">
              <q-card flat class="impactStats q-px-xs">
                {{
                  (baselineData.factoredValue * factorMultiplier) | numberFormat
                }}
                <span class="impactStatsUnit">({{ unit }})</span>
              </q-card>
            </div>
            <div class="col-4">
              <q-card flat class="bg-grey-3 impactStats q-px-xs highlight">
                {{
                  (baselineData.factoredValue *
                    ((100 - reductionPercentage) / 100) *
                    factorMultiplier)
                    | numberFormat
                }}
                <span class="impactStatsUnit">({{ unit }})</span>
              </q-card>
            </div>
            <div class="col-4">
              <q-card flat class="bg-grey-3 impactStats q-px-xs highlight">
                {{
                  (baselineData.factoredValue *
                    (reductionPercentage / 100) *
                    factorMultiplier)
                    | numberFormat
                }}
                <span class="impactStatsUnit">({{ unit }})</span>
              </q-card>
            </div>
          </div>
          <div
            class="row"
            v-if="
              !baselineDataLoading &&
              (baselineData.date == null || baselineData.unitValue == null)
            "
          >
            <div class="col-12">
              <span class="goalBuilder__sentence q-ml-sm">
                Please make sure your select a year that contains data for your
                baseline, Currently you have selected
                <b>{{ baselineFormattedSelectedYear }}</b>
              </span>
            </div>
          </div>
          <div class="row" v-if="baselineDataLoading">
            <div class="col-12">
              <q-skeleton style="height: 40px"></q-skeleton>
            </div>
          </div>
        </div>
      </div>
    </q-card-section>
    <q-card-section class="q-pa-md">
      <div class="row">
        <div class="col"></div>
        <div class="col-auto">
          <q-btn
            :disable="
              !baselineDataLoading &&
              (baselineData.date == null || baselineData.unitValue == null)
            "
            class="saveButton q-px-xs"
            flat
            label="Set Target"
            no-caps
            @click="setTarget"
            :loading="saving"
          >
          </q-btn>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import { getCSSVars } from "@/functions/cssVars";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUserData: "auth/currentUserData",
        data: "businessTargets/current",
        dataLoading: "storyCard/currentLoading",
        outcomes: "outcomes/list",
        baselineData: "outcomes/data/yearTotal",
        baselineDataLoading: "outcomes/data/yearTotalLoading",
      }),
      cssVars() {
        let outcome = this.outcome;
        return getCSSVars(outcome);
      },
      unit() {
        return this.outcome.factorUnitDisplay
          ? this.outcome.factorUnitDisplay
          : this.baselineData && this.baselineData.factoredUnit
          ? this.baselineData.factoredUnit
          : "";
      },
      factorMultiplier() {
        return this.outcome.factorMultiplier ? this.outcome.factorMultiplier : 1;
      },
      dueFormattedSelectedYear: {
        set() {},
        get() {
          if (typeof this.dueSelectedYear === "string") {
            return this.dueSelectedYear.split("/")[0];
          } else {
            return this.dueSelectedYear;
          }
        },
      },
      baselineFormattedSelectedYear: {
        set() {},
        get() {
          if (typeof this.baselineSelectedYear === "string") {
            return this.baselineSelectedYear.split("/")[0];
          } else {
            return this.baselineSelectedYear;
          }
        },
      },
    },
    props: {
      outcome: {
        default: null,
      },
      assessmentTool: {
        default: null,
      },
      closeFunction: {
        default: null,
      },
    },
    data: () => ({
      formData: {
        outcomes_id: null,
        assessmentTool: null,
        baseLineData: 0,
        targetData: 0,
      },

      saving: false,

      reductionPercentage: 0,

      dueYearDialog: false,
      dueSelectedYear:
        new Date(
          new Date().setFullYear(new Date().getFullYear() + 1)
        ).getFullYear() + "/01/01",
      baselineYearDialog: false,
      baselineSelectedYear: null,
    }),
    watch: {
      data: function () {
        this.init();
      },
      selectedOutcome: function () {
        this.initSelectedOutcome();
      },
      $route: {
        handler() {
          this.handleRoute();
        },
        props: true,
      },
      newImage() {
        this.newImageUploaded();
      },
      baselineSelectedYear: function () {
        this.loadBaselineData();
      },
    },
    async mounted() {
      this.loadData();
    },
    methods: {
      getCSSVars: getCSSVars,

      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {
            outcomes_id: null,
            assessmentTool: null,
            baseLineData: 0,
            targetData: 0,
          };
        }
      },

      loadData() {
        this.$store.dispatch("businessTargets/loadAll");

        this.loadBaselineData();
      },
      loadBaselineData() {
        this.$store
          .dispatch("outcomes/data/loadTotalForYear", {
            id: this.outcome.id,
            year: this.baselineSelectedYear,
          })
          .then(() => {
            if (!this.baselineSelectedYear) {
              this.baselineSelectedYear =
                moment(this.baselineData.date).format("YYYY") + "/01/01";
            }
          });
      },

      async setTarget() {
        this.saving = true;
        try {
          let payload = {
            outcomes_id: this.outcome.id,
            assessmentTool: this.assessmentTool,
            baseLineData: this.baselineData.factoredValue * this.factorMultiplier,
            baseLineUnit: this.unit,
            targetData:
              this.baselineData.factoredValue *
              ((100 - this.reductionPercentage) / 100) *
              this.factorMultiplier,
            reducePercent: this.reductionPercentage,
            duebyYear: this.dueFormattedSelectedYear,
            baselineYear: this.baselineFormattedSelectedYear,
          };
          let response = await this.$store.dispatch(
            "businessTargets/save",
            payload
          );
          this.$q.notify({
            position: "top-right",
            type: response.Result == "Success" ? "positive" : "negative",
            message: response.Response.Message,
          });
          this.close();
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an error, Please try again later",
          });
        }
        this.saving = false;
      },
      close() {
        this.closeFunction();
      },

      checkCalendar(val, reason, details) {
        if (reason === "year") {
          this.$refs.baselineYearProxy.hide();
          this.$refs.dueYearProxy.hide();
        }
      },
    },
  };
</script>

<style lang="scss" >
  .setOverallTargetForm {
    h3 {
      font-size: 1.2rem;
      font-weight: 600;
      line-height: 30px;
    }

    .targetFormHeader {
      background: var(--outcome-primary) !important;
      // background: black;
    }
    .suggestedTitle {
      font-weight: 700;
      font-size: 14px;
    }
    .goalBuilder__sentence {
      font-weight: 400;
      font-size: 13px;
    }

    .goalBuilder__stats__title {
      font-weight: 700;
      font-size: 10px;
    }

    .goalBuilder__stats__font {
      font-weight: 900;
      font-size: 18.9913px;
    }

    .goalBuilder__stats__unit {
      font-weight: 900;
      font-size: 11px;
    }

    .impactStatsLabels {
      font-size: 0.8rem;
      font-weight: 700;
    }

    .impactStats {
      font-size: 1.5rem;
      font-weight: 900;
      color: $accent;
    }

    .impactStatsUnit {
      font-size: 1rem;
    }
    .highlight {
      color: var(--outcome-primary);
    }

    .saveButton {
      background: var(--outcome-primary);
      color: white;
      font-size: 0.8rem;
      font-weight: 500;
    }
  }
</style>
